export const EntityTypeOptions = Object.freeze([
    { label: "Sole Proprietor", value: "Sole Proprietor" },
    { label: "Partnership", value: "Partnership" },
    { label: "Limited Liability Company (LLC)", value: "Limited Liability Company (LLC)" },
    { label: "Corporation", value: "Corporation" },
]);